
  // Export
  module.exports =
  {

    // Sign up scripts
    signUp:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Get the password script
        $.getScript(APPLICATION._PATH_PREFIX + 'includes/js/password.js?v=' + APPLICATION._PASSWORD_VERSION, function ()
        {

          // On generating the password
          $('#generate_password').click(function ()
          {

            // Generate the password
            PasswordGenerator.generate(function (password)
            {
          
              // Show the generated password
              $('#generated_password').val(password)
          
              // Enter the password
              $('#password').val(password)

            }
            )

          })

        }
        )

        // On changing the email address
        $('#email_address').not('.js-ignore').change(function ()
        {

          // Get the email address
          $(this).val($(this).val().replace(/ /g, '').toLowerCase())

          // If no email address
          if ('' === $(this).val())
          {

            // Hide company dropdown
            $('#company_id_wrapper').hide()

            // Hide address
            $('#address_wrapper').hide()

          }

          // Otherwise if Persimmon or Charles Church
          else if ($(this).val().match(/@(persimmonhomes|charleschurch)[.]com$/))
          {

            // Show company dropdown
            $('#company_id_wrapper').show()

            // Hide address
            $('#address_wrapper').hide()

          }

          // Otherwise
          else
          {

            // Show address
            $('#address_wrapper').show()

            // Hide company dropdown
            $('#company_id_wrapper').hide()

          }

        }
        ).addClass('js-ignore').trigger('change')

        // On clicking the generated password
        $('#generated_password').not('.js-ignore').click(function ()
        {
          this.select()
        }
        ).addClass('js-ignore')
     
      }

    }

  }